import jQuery from 'jquery';
let $ = jQuery;

HSN.TodaysSpecialCountdown = new function () {
    var displays = new Array();
    var remainingHours, remainingMinutes, remainingSeconds;
    var lastTickTime;
    var timer;

    this.Register = function (element, time, endTime) {
        displays.push($(element));
        var now = new Date(time);
        var end = new Date(endTime);
        var hours = parseInt((end - now) / (3600 * 1000));
        start(hours, end.getMinutes() - now.getMinutes(), end.getSeconds() - now.getSeconds());
    };

    this.Tick = function () {
        var currentTime = new Date();
        updateRemainingTime((currentTime - lastTickTime) / 1000);
        lastTickTime = currentTime;
        displayTime();
    };

    function start(hours, minutes, seconds) {
        if (!timer) {
            remainingHours = hours;
            remainingMinutes = minutes;
            remainingSeconds = seconds;
            lastTickTime = new Date();
            timer = setInterval("HSN.TodaysSpecialCountdown.Tick()", 1000);
        }
        displayTime();
    };

    function displayTime() {
        var displaysLength = displays.length;
        for (var i = 0; i < displaysLength; i++) {
            var d = $(displays[i]);
            d.html(pad(remainingHours) + ":" + pad(remainingMinutes) + ":" + pad(Math.floor(remainingSeconds)));
        }
    }

    function pad(number) {
        return (number >= 10) ? number.toString() : "0" + number;
    }

    function updateRemainingTime(seconds) {
        remainingSeconds = remainingSeconds - seconds;
        if (remainingSeconds <= 0 && remainingMinutes <= 0 && remainingHours <= 0) {
            remainingSeconds = remainingMinutes = remainingHours = 0;
            clearInterval(timer);
            return;
        }
        if (remainingSeconds < 0) {
            remainingMinutes += Math.floor(remainingSeconds / 60);
            remainingSeconds = Math.floor(60 + (remainingSeconds / 60));
        }
        if (remainingMinutes < 0) {
            remainingHours += Math.floor(remainingMinutes / 60);
            remainingMinutes = Math.floor(60 + (remainingMinutes / 60));
        }
    }
};

HSN.TodaysSpecialStatus = new function () {
    var displays = new Array();
    var script = null;
    var timer;
    var value = 0;
    var timeOffset;
    var prefix, suffix;
    var nonTimer = false;
    var productId;
    var scope = this;

    this.AppendScript = function () {
            var url = "/services/tsinventory";
            $.getJSON(url, function (data) {
                var productInventory = $.grep(data, function (inv) {
                    return inv.ProductId === scope.productId;
                })[0];
                scope.Callback(productInventory);
            });
    };

    this.Start = function () {
        if (!script) {
            this.AppendScript();
            timer = setInterval("HSN.TodaysSpecialStatus.Tick()", 15000);
        }
        else {
            HSN.TodaysSpecialStatus.Tick();
        }
    };


    this.Register = function (element, startTime, nonTimr, productId) {
        displays.push($(element));
        timeOffset = new Date() - new Date(startTime);
        this.Start();
        nonTimer = nonTimr;
        this.productId = productId;
    };

    this.StopUpdates = function () {
        if (script != null)
            script.remove();

        clearInterval(timer);
    };

    this.Tick = function () {
        if (script != null)
            script.remove();

        this.AppendScript();
    };

    this.Callback = function (json) {
        if (!json) {
            return;
        }

        this.UpdateText(json);
        value = json.Value;
    };

    this.UpdateText = function (json) {
        if (!json) {
            return;
        }
        switch (json.DisplayCode) {
            case "Sold":
                prefix = " | ";
                suffix = " Sold";
                break;
            case "Remaining":
                prefix = " | Only ";
                suffix = " Remaining";
                break;
            case "LandmarkSold":
                prefix = " | Over ";
                suffix = " Sold";
                break;
            case "LandmarkRemaining":
                prefix = " | Less than ";
                suffix = " Remaining";
                break;
        }

        this.FeatherText(json.Value);
    };

    this.WriteToPage = function (text) {
        var displaysLength = displays.length;
        for (var i = 0; i < displaysLength; i++) {
            var d = $(displays[i]);
            d.html(text);
        }
    };

    this.AddCommas = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    };

    this.FeatherText = function (endValue) {
        if (endValue == -1) {
            HSN.TodaysSpecialStatus.WriteToPage('');
        }
        else if (value == 0) {
            HSN.TodaysSpecialStatus.WriteToPage(prefix + "<span class=\"ts_status\">" + this.AddCommas(endValue) + "</span>" + suffix);
        }
        else {
            var val = parseInt(value);
            var divided = Math.round((endValue - value) / 5);
            HSN.TodaysSpecialStatus.WriteToPage(prefix + "<span class=\"ts_status\">" + this.AddCommas((val + divided)) + "</span>" + suffix);
            setTimeout("HSN.TodaysSpecialStatus.WriteToPage('" + prefix + "<span class=\"ts_status\">" + this.AddCommas((val + (divided * 2))) + "</span>" + suffix + "')", 1000);
            setTimeout("HSN.TodaysSpecialStatus.WriteToPage('" + prefix + "<span class=\"ts_status\">" + this.AddCommas((val + (divided * 3))) + "</span>" + suffix + "')", 2000);
            setTimeout("HSN.TodaysSpecialStatus.WriteToPage('" + prefix + "<span class=\"ts_status\">" + this.AddCommas((val + (divided * 4))) + "</span>" + suffix + "')", 3000);
            setTimeout("HSN.TodaysSpecialStatus.WriteToPage('" + prefix + "<span class=\"ts_status\">" + this.AddCommas((val + (divided * 5))) + "</span>" + suffix + "')", 4000);
        }
    };
};

HSN.TodaysSpecialStatusV2 = new function () {
    var displays = new Array();
    var script = null;
    var timer;
    var value = 0;
    var timeOffset;
    var prefix, suffix;
    var nonTimer = false;
    var scope = this;
    var productId;

    this.AppendScript = function () {
            var url = "/services/tsinventory";
            $.getJSON(url, function (data) {
                var productInventory = $.grep(data, function (inv) {
                    return inv.ProductId === scope.productId;
                })[0];
                scope.Callback(productInventory);
            });
    };

    this.Start = function () {
        if (!script) {
            this.AppendScript();
            timer = setInterval("HSN.TodaysSpecialStatusV2.Tick()", 15000);
        }
        else {
            HSN.TodaysSpecialStatusV2.Tick();
        }
    };

    this.Register = function (element, startTime, nonTimr, productId) {
        displays.push($(element));
        timeOffset = new Date() - new Date(startTime);
        this.Start();
        nonTimer = nonTimr;
        scope.productId = productId;
    };

    this.StopUpdates = function () {
        if (script != null)
            script.remove();

        clearInterval(timer);
    };

    this.Tick = function () {
        if (script != null)
            script.remove();

        this.AppendScript();
    };

    this.Callback = function (json) {
        if (!json) {
            return;
        }

        this.UpdateText(json);
        value = json.Value;
    };

    this.UpdateText = function (json) {
        if (!json) {
            return;
        }

        switch (json.DisplayCode) {
            case "Sold":
                prefix = "";
                suffix = " Sold";
                break;
            case "Remaining":
                prefix = "Only ";
                suffix = " Left";
                break;
            case "LandmarkSold":
                prefix = "Over ";
                suffix = " Sold";
                break;
        }

        this.FeatherText(json.Value);
    };

    this.WriteToPage = function (text) {
        var displaysLength = displays.length;
        for (var i = 0; i < displaysLength; i++) {
            var d = $(displays[i]);
            d.html(text);
        }
    };

    this.AddCommas = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    };

    this.FeatherText = function (endValue) {
        if (endValue == -1) {
            HSN.TodaysSpecialStatusV2.WriteToPage('LIMITED TIME OFFER');
        }
        else if (value == 0) {
            HSN.TodaysSpecialStatusV2.WriteToPage(prefix + "<span style=\"font-weight: bold;\">" + this.AddCommas(endValue) + "</span>" + suffix);
        }
        else {
            var val = parseInt(value);
            var divided = Math.round((endValue - value) / 5);
            HSN.TodaysSpecialStatusV2.WriteToPage(prefix + this.AddCommas((val + divided)) + suffix);
            setTimeout("HSN.TodaysSpecialStatusV2.WriteToPage('" + prefix + this.AddCommas((val + (divided * 2))) + suffix + "')", 1000);
            setTimeout("HSN.TodaysSpecialStatusV2.WriteToPage('" + prefix + this.AddCommas((val + (divided * 3))) + suffix + "')", 2000);
            setTimeout("HSN.TodaysSpecialStatusV2.WriteToPage('" + prefix + this.AddCommas((val + (divided * 4))) + suffix + "')", 3000);
            setTimeout("HSN.TodaysSpecialStatusV2.WriteToPage('" + prefix + this.AddCommas((val + (divided * 5))) + suffix + "')", 4000);
        }
    };
};



// WEBPACK FOOTER //
// ./assets/js/HSN/TodaysSpecial.js